import { Box, BoxProps, Loader, ModalDialog, Spacer, TextNew } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { Header } from '../../components/Header'
import { List } from '../../components/List'
import { SearchFilter } from '../../components/SearchFilter'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { ruleTitles } from '../../utils/constants'
import { RoutingRulesForm } from './RoutingRulesForm'

const RoutingRules = () => {
  const [isModal, setModal] = useState(false)
  const [updateData, setUpdateData] = useState({})
  const [selectedRuleId, setRuleId] = useState(null)
  const [isLoading, setLoading] = useState(true)

  const navigation = useNavigation()

  const { getAllRules, routingRules, accessConfig, getEntityMap } = useStores((store) => ({
    getAllRules: store.routingRule.getAllRules,
    routingRules: store.routingRule.getRoutingList(),
    accessConfig: store.user.getAccessConfig(['static_routing', 'rules']),
    getEntityMap: store.entityMaster.getEntityNameMap,
  }))

  const [getAllRulesApi, getAllRulesApiHandler] = useLazyApiData(getAllRules)
  const [lazygetEntityMap, lazygetEntityMapHandler] = useLazyApiData(getEntityMap)

  useEffect(() => {
    lazygetEntityMap()
  }, [lazygetEntityMap])

  useFocusEffect(
    useCallback(() => {
      if (isAccessible(accessConfig, 'fetch')) {
        getAllRulesApi()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAllRulesApi, navigation]),
  )

  useEffect(() => {
    if (getAllRulesApiHandler.state === 'fulfilled' || getAllRulesApiHandler.state === 'rejected') {
      setLoading(false)
    }
  }, [getAllRulesApiHandler])

  const getFilterKey = (filter: string) => {
    try {
      const keys = Object.keys(ruleTitles).filter((item) => ruleTitles[item] === filter)
      return keys && keys[0]
    } catch (e) {
      throw {
        message: 'Filter error',
      }
    }
  }

  const onSearch = (data: any) => {
    const filterKey = getFilterKey(data?.filter)
    setLoading(true)
    getAllRules(data?.search, filterKey)
  }

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { id: 'Rule Id' },
    { ruleName: 'Rule Name' },
    { payeeType: 'Payee Type' },
    { payeeVpa: 'Payee VPA' },
    { amount: 'Amount' },
    { transactionInitiatingEntityId: 'Entity ID' },
  ]

  // TODO:
  const getFilterData = () => {
    const keys = Object.keys(ruleTitles).map((key, index) => ({
      id: index + 1,
      value: ruleTitles[key],
    }))
    return keys
  }

  const updateRule = (data: any) => {
    setRuleId(data?.id)
    setUpdateData({ merchantId: data?.merchantId, entityId: data?.entityId, instrumentType: data?.instrumentType })
    setModal(true)
  }

  const closeForm = () => {
    setUpdateData({})
    setRuleId(null)
    setModal(false)
  }

  const onItemPress = (item: any) => {
    navigation.navigate('ruleDetails', { id: item.id })
    // updateRule(item)
  }

  const getRuleList = () => {
    if (routingRules.length < 1) {
      return <TextNew>{'No Routing Rules Found'}</TextNew>
    }
    return (
      <Box>
        <List
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          numOfColumns={6}
          sizeConfig={[1, 2, 1, 2, 2, 2]}
          data={routingRules}
          onPress={onItemPress}
        />
      </Box>
    )
  }

  return (
    <Box>
      <Header
        left={{ title: 'Routing Rules', subtitle: ['Routing', 'Routing Rules'] }}
        right={{
          secondOnPress: isAccessible(accessConfig, 'add') && (() => setModal(true)),
          secondTitle: 'Add New Static Rule',
        }}
      />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'fetch') && (
        <Box {...styles.listContainer}>
          <Box alignSelf="flex-end">
            <SearchFilter onSearch={onSearch} isFilter filterData={getFilterData()} />
          </Box>
          <Spacer direction="vertical" size={16} />
          {isLoading && <Loader />}
          {getRuleList()}
        </Box>
      )}
      <ModalDialog
        children={
          <RoutingRulesForm
            initialData={updateData}
            id={selectedRuleId}
            isDeletable={isAccessible(accessConfig, 'delete')}
            isEditable={isAccessible(accessConfig, 'update')}
            onUpdate={closeForm}
            onClose={closeForm}
          />
        }
        show={isModal}
        type={'Right'}
      />
    </Box>
  )
}

export default RoutingRules

const styles = {
  container: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
  } as BoxProps,
  innerContainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 16,
  } as BoxProps,
  listContainer: {
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
  } as BoxProps,
}
